import { defineMessages } from 'react-intl-next';
import type { IntlShape } from 'react-intl-next';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

const i18n = defineMessages({
	title: {
		id: 'editor-offline-storage.version-insertion-error-flag.title',
		defaultMessage: 'Failed to save version',
		description: 'Title for the error flag when version insertion fails',
	},
	description: {
		id: 'editor-offline-storage.version-insertion-error-flag.description',
		defaultMessage:
			'An error occurred while saving your changes. Your content is preserved and you can try again.',
		description: 'Description for the error flag when version insertion fails',
	},
	retryButton: {
		id: 'editor-offline-storage.version-insertion-error-flag.retry-button',
		defaultMessage: 'Retry',
		description: 'Button to retry saving the version',
	},
	dismissButton: {
		id: 'editor-offline-storage.version-insertion-error-flag.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Button to dismiss the error flag',
	},
});

const FLAG_ID = 'version-insertion-error-flag';

export const showVersionInsertionErrorFlag = (
	flags: FlagsStateContainer | undefined,
	intl: IntlShape,
	onRetry: () => void,
	onDismiss: () => void,
) => {
	if (!flags) {
		return;
	}

	void flags.showWarningFlag({
		id: FLAG_ID,
		title: intl.formatMessage(i18n.title),
		description: intl.formatMessage(i18n.description),
		actions: [
			{
				content: intl.formatMessage(i18n.retryButton),
				onClick: () => {
					onRetry();
				},
			},
			{
				content: intl.formatMessage(i18n.dismissButton),
				onClick: () => {
					void flags.hideFlag(FLAG_ID);
					onDismiss();
				},
			},
		],
	});
};

export const hideVersionInsertionErrorFlag = (flags: FlagsStateContainer | undefined) => {
	if (!flags) {
		return;
	}

	void flags.hideFlag(FLAG_ID);
};
